export const compactSelectSx = {
  fontSize: '0.75rem',
  '& .MuiSelect-select': {
    display: 'flex',
    alignItems: 'center',
    minHeight: 'unset',
    paddingTop: 0,
    paddingBottom: 0
  },
  '& .MuiSelect-icon': {
    right: -1,
    top: '50%',
    transform: 'translateY(-50%)'
  }
}

export const compactHeaderSx = {
  fontSize: '0.75rem',
  fontWeight: 'bold',
  width: '100%',
  background: '#2e76a3',
  color: '#f2f2f2',
  padding: '4px 5px',
  lineHeight: 1.2
}

export const compactMenuItemSx = {
  fontSize: '0.75rem'
}
